import { render, staticRenderFns } from "./projectBookingStatusesList.vue?vue&type=template&id=61fdf95d&scoped=true&"
import script from "./projectBookingStatusesList.vue?vue&type=script&lang=js&"
export * from "./projectBookingStatusesList.vue?vue&type=script&lang=js&"
import style0 from "./projectBookingStatusesList.vue?vue&type=style&index=0&id=61fdf95d&lang=scss&scoped=true&"
import style1 from "./projectBookingStatusesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fdf95d",
  null
  
)

export default component.exports